import {
  BankAccountInfoFields,
  BankAccountPaymentMethod
} from './bankAccount/BankAccountFormTypes';
import { CardInfoFields, CardPaymentMethod } from './card/CardFormTypes';
import tokenizePaymentMethod from './Tokenize';

function messageReceived(event: MessageEvent, form: any) {
  if (event.data.eventType === 'tokenize') {
    handleTokenizationMessage(event.data, form);
  }
};

async function handleTokenizationMessage(data: {
  clientKey?: string,
  clientId: string,
  paymentMethodMetadata: any,
  account: any
},
  form: BankAccountInfoFields | CardInfoFields
) {
  const clientId = data.clientKey || data.clientId;
  const paymentMethodMetadata = data.paymentMethodMetadata;
  const account = data.account;
  const isBankAccount = Object.keys(form).includes('routing_number');
  let paymentMethod;

  if (isBankAccount) {
    paymentMethod = new BankAccountPaymentMethod(
      paymentMethodMetadata,
      (form as BankAccountInfoFields)
    );
  }
  else {
    paymentMethod = new CardPaymentMethod(paymentMethodMetadata, (form as CardInfoFields));
  }

  const tokenize = await tokenizePaymentMethod(clientId, paymentMethod, account);
  if (tokenize.error) {
    emitErrors('tokenize', [tokenize.error.code || tokenize.error]);
  } else {
    sendMessage({ eventType: 'tokenize', data: { token: tokenize.id } });
  }
}

function sendMessage(message: { eventType: string, data?: any }) {
  window.parent.postMessage(message, '*');
};

function emitErrors(eventType: string, formattedErrors: string[]) {
  sendMessage({ eventType: eventType, data: { errors: formattedErrors } });
};

export { messageReceived, sendMessage, emitErrors, handleTokenizationMessage };
